import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import ClientList from 'components/ClientList';
import ClientDetail from 'components/ClientDetail';
import OportunidadesList from 'components/oportunidades/OportunidadesList';
import OportunidadesForm from 'components/oportunidades/OportunidadesForm';
import AppRedirect from '../components/shared/AppRedirect';
import isUserHasProfile from '../helpers/profileValidator';
import { GARANTIA_READ, GARANTIA_WRITE } from '../helpers/profilePermission';

// TODO: Modificar permisos para oportunidades
const LoggedInRoutes = ({ user }) => {
  return !user.has_access ? (
    <AppRedirect />
  ) : (
    <Switch>
      {isUserHasProfile(GARANTIA_READ) && (
        <Route exact path="/garantia/clientes" component={ClientList} />
      )}
      {isUserHasProfile(GARANTIA_READ) && (
        <Route exact path="/garantia/clientes/:id/detalle" component={ClientDetail} />
      )}

      {isUserHasProfile(GARANTIA_READ) && (
        <Route exact path="/garantia/oportunidades" component={OportunidadesList} />
      )}

      {isUserHasProfile(GARANTIA_WRITE) && (
        <Route exact path="/garantia/oportunidades/create" component={OportunidadesForm} />
      )}

      {isUserHasProfile(GARANTIA_WRITE) && (
        <Route exact path="/garantia/oportunidades/:id" component={OportunidadesForm} />
      )}

      <Route render={() => <Redirect to="/garantia/clientes" />} />
    </Switch>
  );
};

LoggedInRoutes.propTypes = {
  user: PropTypes.shape({
    has_access: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.login.user,
  };
};

export default withRouter(connect(mapStateToProps)(LoggedInRoutes));
